import { AdditionalExpense } from 'modules/Documents/models/document';
import { VerifactuReimbursableExpenseLine } from 'modules/Documents/models/verifactuDocument';

export const normalizeVerifactuReimbursableExpenseLinesToAdditionalExpenses = (
  reimbursableExpenseLines: VerifactuReimbursableExpenseLine[]
): AdditionalExpense[] => {
  return reimbursableExpenseLines.map((reimbursableExpenseLine) => {
    return {
      id: reimbursableExpenseLine.id,
      description: reimbursableExpenseLine.description,
      expense: reimbursableExpenseLine.amount,
    };
  });
};
